<template lang="html">

  <div class="wrapper noticia">

    <section class="ficha-noticia container">

      <template v-if="!!data">

        <a class="volver" @click="$router.go(-1)">
          < Volver</a>

            <div class="top row-between">
              <!-- <router-link class="categoria" :to="`${$t('enlaces.categorias')}/${data.categoria.slug}`">
                {{data.categoria.nombre}}</router-link> -->
              <h3 class="fecha">{{data.fecha.day}} {{$t(`meses[${Number(data.fecha.month)-1}]`)}} de {{data.fecha.year}}
              </h3>
            </div>

            <h1 v-html="data.titulo"></h1>

            <p class="entradilla"><strong v-html="data.entradilla"></strong></p>

            <img :src="data.img.enlace" alt="" class="img-principal">


            <!-- MODULOS -->
            <template v-for="el in data.modulos">

              <template v-if="!!el">

                <div v-if="el.tipo =='texto'" class="parrafo">
                  <p v-html="el.texto"></p>
                </div>

                <div class="contenedor-imagen" v-if="el.tipo == 'imagen'">
                  <img :src="el.enlace" v-if="!!el.enlace" class="img-full">
                </div>

                <h4 :nivel="el.nivel" v-if="el.tipo == 'destacado'" class="destacado" v-html="el.texto"></h4>

                <h2 v-if="el.tipo == 'titulo'" class="title--sup -green-line -black" v-html="el.value"></h2>

                <iframe :src="$options.filters.urlToID(el.enlace)" v-if="el.tipo == 'video'"></iframe>

                <div class="contenedor-link row-center" v-if="el.tipo == 'link'">

                  <div class="link row-start">
                    <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
                    <img v-if="!!el.meta.image.url" :src="el.meta.image.url" alt="">
                    <h2>{{el.meta.title}}</h2>
                    <p>{{el.meta.description}}</p>
                  </div>

                </div>

                <div class="descargable row-center" v-if="el.tipo == 'file'">
                  <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
                  <span class="icon"></span>
                  <p v-if="!!el.meta.name">{{el.meta.name}}</p>
                </div>

                <ul v-if="el.tipo == 'lista' && el.estilo == 'unordered'">
                  <li v-for="el in el.objectos" v-html="el"></li>
                </ul>

                <ol v-if="el.tipo == 'lista' && el.estilo == 'ordered'">
                  <li v-for="el in el.objectos" v-html="el"></li>
                </ol>

              </template>

            </template>

            <!-- DESCARGABLE -->

            <template v-if='!!data.descargable'>

              <div class="contenedor-descarga row-between">
                <h6 v-html="data.descargable.pie"></h6>
                <a v-if='!!data.descargable.enlace' :href="getServer+data.descargable.enlace" target="_blank"
                  class="download"></a>
              </div>

            </template>

            <!-- //DESCARGABLE//-->

      </template>

      <!-- FIN DE LA FICHA -->

      <p><strong>Comparte en redes sociales</strong></p>

      <div class="rrss-share row-start">

        <a :href="'http://www.facebook.com/sharer.php?u='+url+'&t='+data.titulo" target="_blank" class="link fb"><i
            class="fa fa-facebook"></i></a>
        <a :href="'http://twitter.com/intent/tweet?text='+data.titulo+'&url='+url" target="_blank" class="link twitter"><i
            class="fa fa-twitter"></i></a>
            <a :href="'https://www.linkedin.com/shareArticle?mini=true&url='+url+'&title='+data.titulo" target="_blank" class="link linkedin"><i
              class="fa fa-linkedin"></i></a>
              <a :href="'whatsapp://send?text='+url" data-action="share/whatsapp/share" target="_blank" class="link whatsapp"><i
                class="fa fa-whatsapp"></i></a>

      </div>

    </section>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import fichaFake from '@/components/view-parts/actualidad/ficha-fake'

  export default {
    name: 'ficha-noticia',
    props: [],
    created() {
      this.getNoticia();
    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestNoticia']),
      getNoticia() {
        this.requestNoticia(this.$route.params.id)
          .then((result) => {
            if (!!result) {
              this.data = result;

              document.title = this.data.titulo;
              document.head.querySelector("[name=description]").content = this.data.entradilla;


              if (!!this.data.img.enlace) {
                document.head.querySelector("[property='og:image']").content = this.data.img.enlace;
                document.head.querySelector("[name='twitter:image']").content = this.data.img.enlace;
              }

              document.head.querySelector("[property='og:title']").content = this.data.titulo
              document.head.querySelector("[name='twitter:title']").content = this.data.titulo
              document.head.querySelector("[name='twitter:site']").content = location.href;
              document.head.querySelector("[property='og:description']").content = this.data.entradilla.split(0, 100);
              document.head.querySelector("[name='twitter:description']").content = this.data.entradilla.split(0, 100);

              window.prerenderReady = true;
            } else {
              router.push('/blog');
            }
          })
      }
    },
    computed: {
      ...mapGetters(['getServer']),
      url(){
        return location.href;
      }
    },
    components: {
      'ficha-fake': fichaFake
    },
    watch: {
      '$route'() {
        this.getNoticia();
      }
    },
    filters: {
            urlToID(value) {

                let string;

                if (value.includes('youtube')) {
                    string = 'https://www.youtube.com/embed/' + value.split("?v=")[1];
                } else if (value.includes('vimeo')) {
                    string = 'https://player.vimeo.com/video/' + value.split("/").pop();
                }

                return string;
            }
        },
  }
</script>

<style scoped lang="scss">
  .ficha-noticia {}
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-noticia.vue